import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './design/tokens.css';
import './design/base.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import { persistor,store } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import ThemeProvider from "./app/theme/ThemeProvider";
import ErrorBoundary from "./app/ErrorBoundary";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ThemeProvider>
                    {/* Роутер создаётся в App.js (data router) — нужен для блокировки
                        переходов с несохранёнными изменениями. */}
                    <ErrorBoundary>
                        <App />
                    </ErrorBoundary>
                </ThemeProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
